import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FacilityExportService } from '../../services/facility-export.service';
import { Subscription } from 'rxjs';
import { LoggingMessageService } from '../../services/logging-message.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-facility-export-options',
  templateUrl: './facility-export-options.component.html',
  styleUrl: './facility-export-options.component.css'
})
export class FacilityExportOptionsComponent {

  @Input() hospid: number;
  @Output() exportRequested: EventEmitter<boolean> = new EventEmitter();
  private $subscriptions: Subscription = new Subscription();
  facilityExports = [];
  availableYears: Array<number>;
  availableStartQuarters: Array<number>;
  availableEndQuarters: Array<number>;
  selectedExportID = 1;
  selectedStartYear = 0;
  selectedStartQuarter = 0;
  selectedEndYear = 0;
  selectedEndQuarter = 0;
  displayRawDataMessage = true;
  //displayCalculatedRatesMessage = false;
  exportRequestedMessage = '';
  displayExportRequestedMessage = false;
  showDateValidation: boolean = false;
  dispayRefreshMessage: any = false;
  errorMessage: string = '';

  isExportDisabled(): boolean {    
    if (this.availableEndQuarters.length > 0 && !this.availableEndQuarters.includes(this.selectedEndQuarter))
    {this.selectedEndQuarter = this.availableEndQuarters[0]}

    if (this.availableStartQuarters.length > 0 && !this.availableStartQuarters.includes(this.selectedStartQuarter))
    {this.selectedStartQuarter = this.availableStartQuarters[0]}

    //const isValidExportId: boolean = (this.selectedExportID > 0);
    const isValidYears: boolean = ((this.selectedStartYear > 0) && (this.selectedEndYear > 0) && (this.selectedStartYear <= this.selectedEndYear));
    const isValidQuarters = ((this.selectedStartQuarter > 0) && (this.selectedEndQuarter > 0));
    const isValidDate = (this.selectedStartYear === this.selectedEndYear) ? (this.selectedEndQuarter >= this.selectedStartQuarter) : true;
    const isValid = (isValidYears && isValidQuarters && isValidDate);
    return !isValid || this.errorMessage !== '';
  }

  isDateRangeEnabled(): boolean {
   // const isValidExportId: boolean = (this.selectedExportID > 0);
    const isValidYears: boolean = ((this.selectedStartYear > 0) && (this.selectedEndYear > 0) && (this.selectedStartYear <= this.selectedEndYear));
    const isValidQuarters = ((this.selectedStartQuarter > 0) && (this.selectedEndQuarter > 0));
    const isValidDate = (this.selectedStartYear === this.selectedEndYear) ? (this.selectedEndQuarter > this.selectedStartQuarter) : true;
    const isValid = (isValidYears && isValidQuarters && isValidDate);
    return isValid;
  }


  constructor(private dataService: FacilityExportService, private logger: LoggingMessageService, private authService: AuthService) { }

  ngOnInit() {
    this.resetPeriods();
    this.subscribeToData();
  }

  public getMessageClass() {
    if (this.exportRequestedMessage && this.exportRequestedMessage.toLocaleLowerCase().includes('duplicate')) {
      return 'text-red';
    }
    return '';
  }

  private resetPeriods() {
    this.availableYears = new Array<number>();
    this.availableStartQuarters = [];
    this.availableEndQuarters = [];
    //this.selectedExportID = 0;
    this.selectedStartYear = 0;
    this.selectedStartQuarter = 0;
    this.selectedEndYear = 0;
    this.selectedEndQuarter = 0;
  }

  private subscribeToData() {
    const $exportSubscription = this.dataService.getGetFacilityExport(this.hospid)
      .subscribe((res: any) => {
        this.facilityExports = res.facilityExports;        
        console.log('Facility Exports:', this.facilityExports);
        this.updateAvailableYears();
      });
    this.$subscriptions.add($exportSubscription);
  }

  private setDefaultStartPeriods(exportPeriod: any) {
    this.selectedStartYear = Number(exportPeriod.defaultStartYr);
    this.selectedStartQuarter = Number(exportPeriod.defaultStartQtr);
  }

  private setDefaultEndPeriods(exportPeriod: any) {
    this.selectedEndYear = Number(exportPeriod.defaultEndYr);
    this.selectedEndQuarter = Number(exportPeriod.defaultEndQtr);
  }

  private updateAvailableYears() {
    const exportPeriods = this.facilityExports?.find(e => e.exportID === this.selectedExportID);
    if (exportPeriods && exportPeriods.exportPeriods) {
      const exportPeriod = exportPeriods.exportPeriods[0];
      const yrs: Array<number> = new Array<number>();
      exportPeriod.periods?.forEach(period => {
        yrs.push(Number(period.year));
      });


      this.availableYears = yrs;
      this.availableEndQuarters = new Array<number>();
      this.setDefaultStartPeriods(exportPeriod);
      this.updateAvailableStartQuarters();
      this.setDefaultEndPeriods(exportPeriod);
      this.updateAvailableEndQuarters();
      this.checkDefaultPeriodsAreAvailable();
    } 
    else {
      this.resetPeriods();
    }
  }

  private getExportPeriods(exportID: number): any {
    let matchingPeriods: any;
    const exportPeriods = this.facilityExports.find(e => e.exportID === exportID);
    if (exportPeriods) {
      matchingPeriods = exportPeriods.exportPeriods[0];
    }
    return matchingPeriods;
  }

  private getExportPeriodYear(exportID: number, year: number): any {
    let matchingPeriodYear: any;
    const qtrs: Array<number> = new Array<number>();
    const exportPeriods = this.getExportPeriods(exportID);
    exportPeriods?.periods?.forEach(period => {
      if (period.year === year) {
        matchingPeriodYear = period;
      }
    });
    return matchingPeriodYear;
  }

  private updateAvailableEndQuarters() {
    const qtrs: Array<number> = new Array<number>();
    const period = this.getExportPeriodYear(this.selectedExportID, this.selectedEndYear);
    period?.quarters.forEach(quarter => {
      qtrs.push(Number(quarter));
    });
    this.availableEndQuarters = qtrs;
  }

  private updateAvailableStartQuarters() {
    const qtrs: Array<number> = new Array<number>();
    const period = this.getExportPeriodYear(this.selectedExportID, this.selectedStartYear);
    period?.quarters.forEach(quarter => {
      qtrs.push(Number(quarter));
    });
    this.availableStartQuarters = qtrs;
  }

  private checkDefaultPeriodsAreAvailable() {
    if(!this.availableStartQuarters.includes(this.selectedStartQuarter)) {
      this.selectedStartQuarter = this.availableStartQuarters[0];
    }

    if(!this.availableEndQuarters.includes(this.selectedEndQuarter)) {
      this.selectedEndQuarter = this.availableEndQuarters[0];
    }
  }

  private handleFileExportRequest() {
    this.displayExportRequestedMessage = false;
    const $exportRequestSubscription = this.dataService.generateFacilityExportFile(this.hospid, this.selectedExportID, this.selectedStartYear, this.selectedStartQuarter, this.selectedEndYear, this.selectedEndQuarter)
    .subscribe((res: any) => {
      this.exportRequestedMessage = res.Data.msg;
      this.displayExportRequestedMessage = true;
      this.dispayRefreshMessage = res.ok;
      this.exportRequested.emit(true);
    });
    this.$subscriptions.add($exportRequestSubscription);
  }

  onExportClicked() {
    if(this.selectedEndYear < this.selectedStartYear) {
      this.setDateValidationStatus();
      return;
    } else if ((this.selectedEndYear == this.selectedStartYear) && (this.selectedStartQuarter > this.selectedEndQuarter)) {
      this.setDateValidationStatus();
      return;
    }
    this.showDateValidation = false;
    this.validateDateRange();

    if (this.showDateValidation) {
      return; 
    }
  
    this.handleFileExportRequest();
    this.postWindowMessage();
  }

  setDateValidationStatus() {
    this.showDateValidation = true;
    setTimeout(() => {
      this.showDateValidation = false;
    }, 5000);
  }

  onStartYearSelectionChange($changeValue) {
    this.selectedStartYear = Number($changeValue);
    this.updateAvailableStartQuarters();
    this.validateDateRange();
  }

  onStartQuarterSelectionChange($changeValue) {
    this.selectedStartQuarter = Number($changeValue);
    this.validateDateRange();
  }

  onEndYearSelectionChange($changeValue) {
    this.selectedEndYear = Number($changeValue);
    this.updateAvailableEndQuarters();
    this.validateDateRange();
  }

  onEndQuarterSelectionChange($changeValue) {
    this.selectedEndQuarter = Number($changeValue);
    this.validateDateRange();
  }

  validateDateRange() {
    if (this.availableEndQuarters.length > 0 && !this.availableEndQuarters.includes(this.selectedEndQuarter))
      {this.selectedEndQuarter = this.availableEndQuarters[0]}
  
      if (this.availableStartQuarters.length > 0 && !this.availableStartQuarters.includes(this.selectedStartQuarter))
      {this.selectedStartQuarter = this.availableStartQuarters[0]}
      
    if (this.selectedEndYear < this.selectedStartYear || 
        (this.selectedEndYear === this.selectedStartYear && this.selectedEndQuarter < this.selectedStartQuarter)) {
      this.showDateValidation = true;
      this.errorMessage = 'End Year/qtr must be after start year/qtr. Please revise your selection.';
    } else if (this.calculateQuartersDifference() > 4) {
      this.showDateValidation = true;
      this.errorMessage = 'Number of quarters is limited to 4 quarters.';
    } else {
      this.showDateValidation = false;
      this.errorMessage = '';
    }
  }

  calculateQuartersDifference(): number {
    const startQuarterIndex = (this.selectedStartYear * 4) + this.selectedStartQuarter;
    const endQuarterIndex = (this.selectedEndYear * 4) + this.selectedEndQuarter;
    return endQuarterIndex - startQuarterIndex + 1; // +1 to include both start and end quarters
  }

  private postWindowMessage() {
    setTimeout(() => {
      this.logger.info('facility-export-option.component', 'postWindowMessage', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `facilityID=${this.hospid}`, '');
      window.parent.postMessage('indicatorfactoryaction:', '*');
    }, 0);
  }

  private Unsubscribe() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribe();
  }
}
